import * as React from 'react';
import Layout from '../Layout/Layout';

export default function Reporting() {
  return (
    <Layout pageTitle="Reporting">
    </Layout>
  );
}
